export type AppIconPlatformId = 'ios' | 'android'

export interface IconSize {
  pixels: number
  fileName: string
  label: string
}

export interface IconPlatform {
  id: AppIconPlatformId
  folder: string
  sizes: IconSize[]
}

const IOS_SIZES: IconSize[] = [
  {pixels: 40, fileName: 'AppIcon-20@2x.png', label: 'iPhone Notification 20pt @2x'},
  {pixels: 60, fileName: 'AppIcon-20@3x.png', label: 'iPhone Notification 20pt @3x'},
  {pixels: 58, fileName: 'AppIcon-29@2x.png', label: 'iPhone Settings 29pt @2x'},
  {pixels: 87, fileName: 'AppIcon-29@3x.png', label: 'iPhone Settings 29pt @3x'},
  {pixels: 80, fileName: 'AppIcon-40@2x.png', label: 'iPhone Spotlight 40pt @2x'},
  {pixels: 120, fileName: 'AppIcon-40@3x.png', label: 'iPhone Spotlight 40pt @3x'},
  {pixels: 120, fileName: 'AppIcon-60@2x.png', label: 'iPhone App 60pt @2x'},
  {pixels: 180, fileName: 'AppIcon-60@3x.png', label: 'iPhone App 60pt @3x'},
  {pixels: 20, fileName: 'AppIcon-20-ipad.png', label: 'iPad Notification 20pt @1x'},
  {pixels: 40, fileName: 'AppIcon-20@2x-ipad.png', label: 'iPad Notification 20pt @2x'},
  {pixels: 29, fileName: 'AppIcon-29-ipad.png', label: 'iPad Settings 29pt @1x'},
  {pixels: 58, fileName: 'AppIcon-29@2x-ipad.png', label: 'iPad Settings 29pt @2x'},
  {pixels: 40, fileName: 'AppIcon-40-ipad.png', label: 'iPad Spotlight 40pt @1x'},
  {pixels: 80, fileName: 'AppIcon-40@2x-ipad.png', label: 'iPad Spotlight 40pt @2x'},
  {pixels: 76, fileName: 'AppIcon-76-ipad.png', label: 'iPad App 76pt @1x'},
  {pixels: 152, fileName: 'AppIcon-76@2x-ipad.png', label: 'iPad App 76pt @2x'},
  {pixels: 167, fileName: 'AppIcon-83.5@2x-ipad.png', label: 'iPad Pro App 83.5pt @2x'},
  {pixels: 1024, fileName: 'AppIcon-1024.png', label: 'App Store Marketing 1024×1024'},
]

const ANDROID_SIZES: IconSize[] = [
  {pixels: 48, fileName: 'mipmap-mdpi/ic_launcher.png', label: 'mdpi 48×48'},
  {pixels: 72, fileName: 'mipmap-hdpi/ic_launcher.png', label: 'hdpi 72×72'},
  {pixels: 96, fileName: 'mipmap-xhdpi/ic_launcher.png', label: 'xhdpi 96×96'},
  {pixels: 144, fileName: 'mipmap-xxhdpi/ic_launcher.png', label: 'xxhdpi 144×144'},
  {pixels: 192, fileName: 'mipmap-xxxhdpi/ic_launcher.png', label: 'xxxhdpi 192×192'},
  {pixels: 512, fileName: 'play-store-icon.png', label: 'Play Store 512×512'},
]

export const APP_ICON_PLATFORMS: IconPlatform[] = [
  {id: 'ios', folder: 'ios/AppIcon.appiconset', sizes: IOS_SIZES},
  {id: 'android', folder: 'android', sizes: ANDROID_SIZES},
]
